import { Controller } from "@hotwired/stimulus"
import IMask, { InputMask } from "imask"

export default class extends Controller {
  static values = {
    hideUnit: Boolean,
    max: Number,
  }
  mask: InputMask;
  declare readonly hideUnitValue?: boolean;
  declare readonly maxValue?: number;
  declare readonly hasMaxValue: boolean;

  connect() {
    const input = this.element as HTMLInputElement
    const maskOptions = {
      mask: `${this.hideUnitValue ? '' : '$'}num`,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: ',',
          padFractionalZeros: true,
          normalizeZeros: true,
          radix: '.',
          mapToRadix: [".", ","],
          ...(this.hasMaxValue ? { max: this.maxValue } : {})
        }
      }
    }
    this.mask = IMask(input, maskOptions)
  }
}
